// extracted by mini-css-extract-plugin
export default {"inputTitle":"TitlePollForm_inputTitle__+OiXu"};